import React from 'react';

import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';

import { IDescriptionValue } from './interfaces';
import {
  DescriptionAmount,
  DescriptionCurrencyRange,
  DescriptionDate,
  DescriptionDateRange,
  DescriptionDecimal,
  DescriptionLink,
  DescriptionMetadata,
  DescriptionPercent,
  DescriptionRangeDecimal,
  DescriptionSkeleton,
  DescriptionStatus,
  DescriptionText,
  DescriptionTypographyList,
} from './types';

export const types: { [index: string]: any } = {
  link: DescriptionLink,
  text: DescriptionText,
  status: DescriptionStatus,
  metadata: DescriptionMetadata,
  date: DescriptionDate,
  dateRange: DescriptionDateRange,
  amount: DescriptionAmount,
  percent: DescriptionPercent,
  typographyList: DescriptionTypographyList,
  decimal: DescriptionDecimal,
  decimalRange: DescriptionRangeDecimal,
  currencyRange: DescriptionCurrencyRange,
  skeleton: DescriptionSkeleton,
};

const DescriptionValue: React.FC<IDescriptionValue> = ({
  value,
  type,
  ...otherProps
}) => {
  let typeFactory: any = ({ value }: { [value: string]: any }) => value;

  if (type) {
    if (isFunction(type) || React.isValidElement(type)) {
      typeFactory = type;
    } else if (isString(type)) {
      typeFactory = types[type];
    }
  }

  return React.createElement(typeFactory, {
    ...otherProps,
    value: value,
  });
};

export default DescriptionValue;
